/*
 * Promo Flyout — globales, delegiertes Verhalten + "Portal"-Pattern.
 *
 * EINBINDUNG DES TRIGGERS (update-sicher): layout/theme.liquid rendert die Snippets
 * 'promo-flyout' (desktop + mobile) in einen versteckten Container [data-pf-source].
 * ensureTriggers() verschiebt die beiden .pf-root-Knoten per JS in die rechte Header-
 * Leiste (vor den Warenkorb). sections/header.liquid bleibt dadurch UNVERÄNDERT und
 * wird von Theme-Updates nicht mehr überschrieben. Die Knoten-Referenzen bleiben im
 * Speicher, falls eine App den Header per AJAX neu rendert (dann wird neu eingesetzt).
 *
 * WARUM GLOBAL STATT INLINE IM SNIPPET: Manche Shop-Header werden nach dem Laden
 * per AJAX neu gerendert; Inline-<script>-Tags werden dabei nicht ausgeführt. Diese
 * Datei wird EINMAL global geladen und bindet Klicks über ein delegiertes Event.
 *
 * "PORTAL": Ein CSS-`transform` am Header erzeugt einen containing block für
 * `position: fixed`; das Panel wäre dann nur header-hoch. Deshalb wird
 * .pf-panel/.pf-overlay nach document.body verschoben (Verbindung per IDs).
 *
 * "DEAL DES TAGES": Das Snippet bettet eine JSON-Dateninsel mit allen verfügbaren,
 * rabattierten Produkten ein; welches heute gezeigt wird, entscheidet diese Datei per
 * Datums-Index (Tag im Jahr, UTC) – cache-sicher, ohne Deploy/Cronjob.
 *
 * WARENKORB-ZÄHLER: syncCartCount() blendet die "0" aus (Klasse pf-cart-empty).
 *
 * GRÖSSE-SCHNELLFILTER (mobil): [data-pf-size-filter] in snippets/mobile-filters.liquid
 * öffnet den Filter-Drawer des Themes und klappt dort "Größen" auf.
 *
 * MOBILE SUCHE: assets/pf-mobile-search.js, wird am Ende dieser Datei nachgeladen.
 */
(function () {
  if (window.__pfInit) return;
  window.__pfInit = true;

  var pfScript = document.currentScript;
  var pfRoots = null;

  function parseDate(value) {
    if (!value) return null;
    var d = new Date(value);
    return isNaN(d.getTime()) ? null : d;
  }

  function isActive(el) {
    var now = new Date();
    var start = parseDate(el.getAttribute('data-start'));
    var end = parseDate(el.getAttribute('data-end'));
    if (start && now < start) return false;
    if (end && now > end) return false;
    return true;
  }

  function formatCountdown(ms) {
    if (ms <= 0) return '';
    var days = Math.floor(ms / 86400000);
    var hours = Math.floor((ms % 86400000) / 3600000);
    var mins = Math.floor((ms % 3600000) / 60000);
    if (days > 0) return 'Endet in ' + days + ' Tag' + (days === 1 ? '' : 'en') + ' ' + hours + ' Std.';
    if (hours > 0) return 'Endet in ' + hours + ' Std. ' + mins + ' Min.';
    return 'Endet in ' + mins + ' Min.';
  }

  function overlayIdForPanel(panelId) {
    return panelId.replace('pf-panel-', 'pf-overlay-');
  }

  function panelIdForOverlay(overlayId) {
    return overlayId.replace('pf-overlay-', 'pf-panel-');
  }

  function getPanelForRoot(root) {
    var trigger = root.querySelector('.pf-trigger');
    var panelId = trigger && trigger.getAttribute('aria-controls');
    return panelId ? document.getElementById(panelId) : null;
  }

  function getOverlayForPanel(panel) {
    if (!panel || !panel.id) return null;
    return document.getElementById(overlayIdForPanel(panel.id));
  }

  function getTriggerForPanel(panel) {
    if (!panel || !panel.id) return null;
    return document.querySelector('[aria-controls="' + panel.id + '"]');
  }

  // Trigger-Knoten (Desktop + Mobil) aus dem versteckten Quell-Container in den Header setzen.
  function ensureTriggers() {
    if (!pfRoots) {
      var src = document.querySelector('[data-pf-source]');
      if (!src) return;
      pfRoots = Array.prototype.slice.call(src.querySelectorAll('.pf-root'));
    }
    var targets = [
      '.header__row-desktop.lower .header__row-segment.right',
      '.header__row-mobile .header__row-segment.right'
    ];
    pfRoots.forEach(function (root, i) {
      var seg = document.querySelector(targets[i]);
      if (!seg || seg.contains(root)) return;
      var cart = seg.querySelector('[data-js-cart-icon]');
      if (cart && cart.parentNode === seg) seg.insertBefore(root, cart);
      else seg.appendChild(root);
    });
  }

  // Verschiebt Panel/Overlay eines Roots nach document.body, falls sie das
  // noch nicht sind. Räumt dabei auch Altlasten mit derselben ID auf.
  function portalRoot(root) {
    var panel = root.querySelector('.pf-panel');
    if (panel && panel.parentElement !== document.body) {
      var dupePanel = document.getElementById(panel.id);
      if (dupePanel && dupePanel !== panel) dupePanel.remove();
      document.body.appendChild(panel);
    }
    var overlay = root.querySelector('.pf-overlay');
    if (overlay && overlay.parentElement !== document.body) {
      var dupeOverlay = overlay.id ? document.getElementById(overlay.id) : null;
      if (dupeOverlay && dupeOverlay !== overlay) dupeOverlay.remove();
      document.body.appendChild(overlay);
    }
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str == null ? '' : String(str);
    return div.innerHTML;
  }

  // Tag im Jahr (UTC), stabil für alle Besucher am selben Kalendertag.
  function dayIndexUTC() {
    var now = new Date();
    var start = Date.UTC(now.getUTCFullYear(), 0, 0);
    var today = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
    return Math.floor((today - start) / 86400000);
  }

  function renderDeal(panel) {
    var scriptEl = panel.querySelector('.pf-deal-pool');
    var dealEl = panel.querySelector('.pf-deal');
    if (!scriptEl || !dealEl) return;

    var pool;
    try {
      pool = JSON.parse(scriptEl.textContent);
    } catch (e) {
      dealEl.hidden = true;
      return;
    }
    if (!pool || !pool.length) {
      dealEl.hidden = true;
      return;
    }

    var idx = dayIndexUTC() % pool.length;
    var deal = pool[idx];
    var key = idx + '|' + deal.url;
    if (dealEl.getAttribute('data-pf-deal-key') === key) return; // schon aktuell

    var url = escapeHtml(deal.url);
    var badge = '<span class="pf-deal__badge">&minus;' + escapeHtml(deal.discount) + '&nbsp;%</span>';
    var mediaHtml = deal.image
      ? '<a class="pf-deal__media" href="' + url + '" tabindex="-1" aria-hidden="true">' +
          '<img src="' + escapeHtml(deal.image) + '" alt="" loading="lazy">' + badge +
        '</a>'
      : '';

    dealEl.innerHTML =
      '<article class="pf-deal__card">' +
        mediaHtml +
        '<div class="pf-deal__content">' +
          '<span class="pf-deal__eyebrow">Deal des Tages</span>' +
          '<h3 class="pf-deal__title"><a href="' + url + '">' + escapeHtml(deal.title) + '</a></h3>' +
          '<p class="pf-deal__price">' +
            '<span class="pf-deal__price-now">' + escapeHtml(deal.price) + '</span>' +
            '<span class="pf-deal__price-old">' + escapeHtml(deal.compareAtPrice) + '</span>' +
          '</p>' +
          '<a href="' + url + '" class="pf-btn">Jetzt entdecken <span aria-hidden="true">&rarr;</span></a>' +
        '</div>' +
      '</article>';
    dealEl.hidden = false;
    dealEl.setAttribute('data-pf-deal-key', key);
  }

  function refreshRoot(root) {
    portalRoot(root);

    var panel = getPanelForRoot(root);
    var trigger = root.querySelector('.pf-trigger');
    var countEl = root.querySelector('.pf-trigger__count');
    if (!panel) {
      if (countEl) countEl.hidden = true;
      return;
    }

    renderDeal(panel);

    var items = panel.querySelectorAll('.pf-item');
    var emptyEl = panel.querySelector('.pf-empty');
    var labelEl = panel.querySelector('.pf-list__label');
    var dealEl = panel.querySelector('.pf-deal');
    var activeCount = 0;

    items.forEach(function (el) {
      var active = isActive(el);
      el.hidden = !active;
      if (active) {
        activeCount++;
        var cd = el.querySelector('.pf-item__countdown');
        if (cd) {
          var end = parseDate(cd.getAttribute('data-end'));
          if (end) {
            var txt = formatCountdown(end - new Date());
            var cdText = cd.querySelector('.pf-item__countdown-text');
            if (cdText) cdText.textContent = txt;
            cd.hidden = !txt;
          }
        }
      }
    });

    var dealVisible = !!dealEl && !dealEl.hidden;

    if (countEl) {
      countEl.textContent = activeCount;
      countEl.hidden = activeCount === 0 && !dealVisible;
    }
    if (trigger) {
      trigger.setAttribute('aria-label', activeCount > 0 ? ('Aktionen (' + activeCount + ' aktiv)') : 'Aktionen');
    }
    // Zwischenüberschrift nur, wenn es neben dem Deal auch Aktionen gibt
    if (labelEl) labelEl.hidden = activeCount === 0 || !dealVisible;
    if (emptyEl) emptyEl.hidden = activeCount !== 0 || dealVisible;
  }

  // Warenkorb-Zähler nur zeigen, wenn mindestens 1 Artikel drin liegt.
  function syncCartCount() {
    document.querySelectorAll('[data-js-cart-count]').forEach(function (el) {
      el.classList.toggle('pf-cart-empty', !(parseInt(el.textContent, 10) > 0));
      if (!el.__pfObs) {
        el.__pfObs = new MutationObserver(syncCartCount);
        el.__pfObs.observe(el, { childList: true, characterData: true, subtree: true });
      }
    });
  }

  function refreshAll() {
    ensureTriggers();
    (pfRoots || document.querySelectorAll('.pf-root')).forEach(refreshRoot);
    syncCartCount();
  }

  function openPanel(panel) {
    var overlay = getOverlayForPanel(panel);
    var trigger = getTriggerForPanel(panel);
    panel.hidden = false;
    if (overlay) overlay.hidden = false;
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(function () {
      panel.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
    });
  }

  function closePanel(panel) {
    var overlay = getOverlayForPanel(panel);
    var trigger = getTriggerForPanel(panel);
    panel.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    window.setTimeout(function () {
      panel.hidden = true;
      if (overlay) overlay.hidden = true;
    }, 300);
  }

  // "Größe"-Schnellfilter: Filter-Drawer öffnen und Gruppe "Größen" aufklappen.
  function openSizeFilter() {
    var opener = document.querySelector('[data-mobile-filters-toggle]');
    if (!opener) return;
    opener.click();
    window.setTimeout(function () {
      var toggles = document.querySelectorAll('.filter-drawer__group-toggle');
      for (var i = 0; i < toggles.length; i++) {
        var label = toggles[i].querySelector('.filter-drawer__group-toggle-label');
        if (label && /gr(ö|oe)ß|size/i.test(label.textContent)) {
          if (toggles[i].getAttribute('aria-expanded') !== 'true') toggles[i].click();
          toggles[i].scrollIntoView({ block: 'start', behavior: 'smooth' });
          break;
        }
      }
    }, 400);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.pf-panel.is-open').forEach(closePanel);
  });

  document.addEventListener('click', function (e) {
    var sizeBtn = e.target.closest('[data-pf-size-filter]');
    if (sizeBtn) {
      openSizeFilter();
      return;
    }

    var trigger = e.target.closest('.pf-trigger');
    if (trigger) {
      var panelId = trigger.getAttribute('aria-controls');
      var panel = panelId && document.getElementById(panelId);
      if (!panel) return;
      if (panel.hidden) {
        openPanel(panel);
      } else {
        closePanel(panel);
      }
      return;
    }

    var closeBtn = e.target.closest('.pf-panel__close');
    if (closeBtn) {
      var panel2 = closeBtn.closest('.pf-panel');
      if (panel2) closePanel(panel2);
      return;
    }

    var overlay = e.target.closest('.pf-overlay');
    if (overlay && overlay.id) {
      var panel3 = document.getElementById(panelIdForOverlay(overlay.id));
      if (panel3) closePanel(panel3);
      return;
    }

    var codeBtn = e.target.closest('.pf-item__code');
    if (codeBtn) {
      var code = codeBtn.getAttribute('data-code');
      if (navigator.clipboard && code) {
        navigator.clipboard.writeText(code).then(function () {
          var hint = codeBtn.querySelector('.pf-item__code-hint');
          if (!hint) return;
          var original = hint.textContent;
          hint.textContent = 'Kopiert!';
          window.setTimeout(function () {
            hint.textContent = original;
          }, 1500);
        });
      }
      return;
    }
  });

  refreshAll();
  // Alle 15 s: Countdown/aktiv-Status, "Deal des Tages" bei Tageswechsel, Portal für
  // neu aufgetauchte Panels, Trigger nach Header-Rerender neu einsetzen.
  window.setInterval(refreshAll, 15000);
  // Zusätzlich kurz nach dem Laden: falls der Header erst später fertig gerendert wird
  window.addEventListener('load', ensureTriggers);

  // Mobile Suche nachladen (liegt als Geschwister-Datei im selben Asset-Ordner)
  var src = pfScript && pfScript.src;
  if (!src) {
    var found = document.querySelector('script[src*="promo-flyout.js"]');
    src = found && found.src;
  }
  if (src) {
    var ms = document.createElement('script');
    ms.src = src.replace('promo-flyout.js', 'pf-mobile-search.js');
    ms.async = true;
    document.head.appendChild(ms);
  }
})();